import React from 'react';

const Hero = () => {
  return (
    <section id="hero" style={styles.hero}>
      <div style={styles.heroContent}>
        <div style={styles.contentWrapper}>
          <span style={styles.badge}>✨ Welcome to Culinary Excellence</span>
          <h1 style={styles.title}>
            Experience The Art<br />
            <span style={styles.titleAccent}>Of Fine Dining</span>
          </h1>
          <p style={styles.subtitle}>
            Indulge in exquisite flavors crafted with passion and served with love.
            Every dish tells a story, every bite is a journey.
          </p>
          <div style={styles.buttonGroup}>
            <button style={styles.primaryButton}>View Menu</button>
            <button style={styles.secondaryButton}>
              <span style={styles.playIcon}>▶</span> Watch Video
            </button>
          </div>
          <div style={styles.stats}>
            <div style={styles.statItem}>
              <div style={styles.statNumber}>15+</div>
              <div style={styles.statLabel}>Years Experience</div>
            </div>
            <div style={styles.statDivider}></div>
            <div style={styles.statItem}>
              <div style={styles.statNumber}>50+</div>
              <div style={styles.statLabel}>Master Chefs</div>
            </div>
            <div style={styles.statDivider}></div>
            <div style={styles.statItem}>
              <div style={styles.statNumber}>200+</div>
              <div style={styles.statLabel}>Menu Items</div>
            </div>
          </div>
        </div>
        <div style={styles.imageWrapper}>
          <div style={styles.heroImage}>
            <div style={styles.imagePlaceholder}>
              <span style={styles.imageEmoji}>🍝</span>
            </div>
            <div style={styles.floatingCard1}>
              <span style={styles.cardEmoji}>⭐</span>
              <div>
                <div style={styles.cardTitle}>4.9 Rating</div>
                <div style={styles.cardSubtitle}>2000+ Reviews</div>
              </div>
            </div>
            <div style={styles.floatingCard2}>
              <span style={styles.cardEmoji}>🔥</span>
              <div>
                <div style={styles.cardTitle}>Popular</div>
                <div style={styles.cardSubtitle}>Signature Dish</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={styles.scrollIndicator}>
        <div style={styles.mouse}></div>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fff 0%, #f5f0e8 50%, #fff 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    marginTop: '80px',
    padding: '4rem 2rem',
    overflow: 'hidden',
  },
  heroContent: {
    maxWidth: '1400px',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '4rem',
    alignItems: 'center',
  },
  contentWrapper: {
    zIndex: 2,
  },
  badge: {
    display: 'inline-block',
    padding: '0.6rem 1.5rem',
    backgroundColor: 'rgba(139, 46, 59, 0.1)',
    color: 'var(--maroon)',
    borderRadius: '50px',
    fontSize: '0.9rem',
    fontWeight: '600',
    marginBottom: '1.5rem',
  },
  title: {
    fontSize: '4.5rem',
    fontWeight: '800',
    color: 'var(--dark)',
    marginBottom: '1.5rem',
    lineHeight: '1.1',
    letterSpacing: '-2px',
  },
  titleAccent: {
    color: 'var(--maroon)',
    display: 'block',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#666',
    marginBottom: '2.5rem',
    lineHeight: '1.8',
    maxWidth: '500px',
  },
  buttonGroup: {
    display: 'flex',
    gap: '1.5rem',
    marginBottom: '3rem',
    flexWrap: 'wrap',
  },
  primaryButton: {
    backgroundColor: 'var(--maroon)',
    color: 'var(--white)',
    padding: '1.2rem 2.8rem',
    fontSize: '1.1rem',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    fontWeight: '700',
    transition: 'all 0.3s ease',
    boxShadow: '0 10px 30px rgba(139, 46, 59, 0.3)',
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    color: 'var(--dark)',
    padding: '1.2rem 2.8rem',
    fontSize: '1.1rem',
    border: '2px solid var(--dark)',
    borderRadius: '50px',
    cursor: 'pointer',
    fontWeight: '700',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  playIcon: {
    fontSize: '0.8rem',
  },
  stats: {
    display: 'flex',
    gap: '2rem',
    alignItems: 'center',
  },
  statItem: {
    textAlign: 'center',
  },
  statNumber: {
    fontSize: '2.5rem',
    fontWeight: '800',
    color: 'var(--maroon)',
    marginBottom: '0.3rem',
  },
  statLabel: {
    fontSize: '0.9rem',
    color: '#666',
    fontWeight: '500',
  },
  statDivider: {
    width: '1px',
    height: '40px',
    backgroundColor: '#ddd',
  },
  imageWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  heroImage: {
    position: 'relative',
    width: '100%',
    maxWidth: '550px',
  },
  imagePlaceholder: {
    width: '100%',
    height: '550px',
    backgroundColor: 'var(--cream)',
    borderRadius: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
    position: 'relative',
    overflow: 'hidden',
  },
  imageEmoji: {
    fontSize: '8rem',
  },
  floatingCard1: {
    position: 'absolute',
    top: '10%',
    right: '-10%',
    backgroundColor: 'var(--white)',
    padding: '1.5rem',
    borderRadius: '20px',
    boxShadow: '0 15px 40px rgba(0,0,0,0.15)',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    animation: 'float 3s ease-in-out infinite',
  },
  floatingCard2: {
    position: 'absolute',
    bottom: '15%',
    left: '-10%',
    backgroundColor: 'var(--white)',
    padding: '1.5rem',
    borderRadius: '20px',
    boxShadow: '0 15px 40px rgba(0,0,0,0.15)',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    animation: 'float 3s ease-in-out infinite 1.5s',
  },
  cardEmoji: {
    fontSize: '2rem',
  },
  cardTitle: {
    fontSize: '1.1rem',
    fontWeight: '700',
    color: 'var(--dark)',
    marginBottom: '0.2rem',
  },
  cardSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
  },
  scrollIndicator: {
    position: 'absolute',
    bottom: '2rem',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  mouse: {
    width: '30px',
    height: '50px',
    border: '2px solid var(--maroon)',
    borderRadius: '25px',
    position: 'relative',
  },
};

export default Hero;